import * as React from 'react';
import kwadHubArtwork from 'images/KwadHub-Artwork-2.png';
import { Box, SxProps, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface KwadhubArtworkProps {
  sx?: SxProps<Theme>;
}

const KwadhubArtwork: React.FC<KwadhubArtworkProps> = ({ sx }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                ...sx,
            }}
        >
            <Box
                component="img"
                src={kwadHubArtwork}
                alt="KwadHub Artwork"
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    filter: 'url(#outline)',
                }}
            />
            <svg width="0" height="0">
                <filter id="outline">
                    <feMorphology in="SourceAlpha" operator="dilate" radius={theme.outline} result="dilated" />
                    <feGaussianBlur in="dilated" stdDeviation={theme.outline} result="blurred" />
                    <feFlood floodColor={theme.palette.primary.shadow} floodOpacity={theme.alpha * 2} result="color" />
                    <feComposite in="color" in2="blurred" operator="in" result="outline" />
                    <feMerge>
                        <feMergeNode in="outline" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </svg>
        </Box>
    );
};

export default KwadhubArtwork;
